import { useState } from "react";
import { Modal, Button, SelectPicker } from "rsuite";
import { TypeTemplate, templateTypePicker } from "../../config";
import { AppRouteApi } from "../../config/appRoute";
import { LibExport } from "../../libs";

export function ModalTemplateDownload({
  handleClose,
}: {
  handleClose: Function;
}) {
  const [option, setOption] = useState<TypeTemplate>();

  const handleDownload = () => {
    const url = AppRouteApi.Download.Template(option!);
    LibExport.DownloadExport(url);
    handleClose();
  };

  return (
    <Modal open={true} onClose={() => handleClose()}>
      <Modal.Body>
        <div className="container">
          <div className="row">
            <div className="col col-md-6 d-flex align-items-center">
              Select Template Type
            </div>
            <div className="col col-md-6">
              <SelectPicker
                data={templateTypePicker}
                style={{ width: "100%" }}
                onChange={(value) => setOption(value as TypeTemplate)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={!option}
          onClick={handleDownload}
          appearance="primary"
        >
          Download
        </Button>
        <Button onClick={() => handleClose()} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
